import { FormType } from './../../../form-types';
import { TravelKitQuestionFieldAnswers } from './questions';

const travelKit: FormType<TravelKitQuestionFieldAnswers> = {
  name: 'Travel Kit',
  questions: [
    {
      key: 'travelKit_initialConsent',
      next: {
        condition: {
          'travelKit_initialConsent.consent': true
        },
        key: 'travelKit_sex',
        els: 'travelKit_ineligible'
      }
    },
    {
      key: 'travelKit_sex',
      next: {
        condition: {
          'travelKit_sex.female': true
        },
        key: 'travelKit_pregnancyStatus',
        els: 'travelKit_height'
      }
    },
    {
      key: 'travelKit_pregnancyStatus',
      next: {
        condition: {
          'travelKit_pregnancyStatus.yes': true
        },
        key: 'travelKit_ineligible',
        els: 'travelKit_consentPregnancy'
      }
    },
    {
      key: 'travelKit_consentPregnancy',
      next: {
        condition: {
          'travelKit_consentPregnancy.consent': true
        },
        key: 'travelKit_height',
        els: 'travelKit_ineligible'
      }
    },
    'travelKit_height',
    'travelKit_weight',
    'travelKit_recentCheckup',
    'travelKit_hasPcp',
    'travelKit_altitudeSickness',
    'travelKit_malariaProphylaxis',
    {
      key: 'travelKit_kidneyLiverFailure',
      next: {
        condition: {
          'travelKit_kidneyLiverFailure.yes': true
        },
        key: 'travelKit_ineligible',
        els: 'travelKit_medicationAllergies'
      }
    },
    'travelKit_medicationAllergies',
    'travelKit_additionalInfo',
    {
      key: 'travelKit_consentTruthfulness',
      next: {
        condition: {
          'travelKit_consentTruthfulness.consent': true
        },
        key: 'travelKit_consentEmergencyUse',
        els: 'travelKit_ineligible'
      }
    },
    {
      key: 'travelKit_consentEmergencyUse',
      next: {
        condition: {
          'travelKit_consentEmergencyUse.consent': true
        },
        key: 'travelKit_complete',
        els: 'travelKit_ineligible'
      }
    },

    'travelKit_ineligible',
    'travelKit_complete'
  ]
};

export default travelKit;
